import React from "react";
/// React router dom
import { Routes, Route, Outlet } from "react-router-dom";
/// Css
import "./index.css";
import "./Css/CustomCss.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";



import ScrollToTop from "./layouts/ScrollToTop";
 

import Terms from "./pages/TermsConditon";
import PrivacyPolicy from "./pages/PrivacyPolicy";
 
import About from "./pages/About";
 

 
 

import Listing from "./pages/Listing";
import FlatDetailPage from "./pages/ListingDetail";
import SendNotification from "./pages/Notification";
import Dashboards from "./pages/DashBoard";
import Waitlist from "./pages/Waitlist";
import Userlist from "./pages/UserList"
import { Users } from "lucide-react";
import UserDetailPage from "./pages/UserDetail";
import AboutForm from "./pages/AboutUsForm";
import ContactList from "./pages/ContactList";
import NewRequest from "./pages/Newrequest";
import DeleteUsers from "./pages/DeleteAccounts";
import Role from "./pages/Role";
import CreateAdmin from "./pages/CreateAdmin";
 import ProtectedRoute from "./components/ProtectedRoutes";
import AccessDenied from "./pages/AccessDenied";
import SafetyChecks from "./pages/SafetyCheck";
import AlertPage from "./pages/Alerts";
import BlockList from "./pages/BlockedChat";
import ReportedUser from "./pages/ReportedChat";
import BlockedChats from "./pages/BlockedChat";
import ChatUI from "./pages/ChatView";
 
import NoInternet from "./pages/NoInternet";
import useOnlineStatus from "./components/InternetHook";
import { HomeRedirect } from "./pages/HomeRedirect";
import ExpressInterest from "./pages/ExpressIntrest";
import InterestedUsersPage from "./pages/IntrestedAdsDetail";

const Markup = () => {

   const isOnline = useOnlineStatus();
  
    if (!isOnline) {
      return <NoInternet />;
    }
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

 
  const allroutes = [
    /// Dashboard


    // <Route path="/" element={<HomeRedirect />} />
   
 {
    url: "/",
    component: <HomeRedirect/>
       
    
  },
  //  {
  //   url: "/she-rent",
  //   component: <HomeRedirect/>
       
    
  // },

    // { url: "", component: (
    //   <ProtectedRoute permissionKey="isDashboard">
    //     <Dashboards />
    //   </ProtectedRoute>
    // ),},
    
      {
    url: "dashboard",
    component: (
      <ProtectedRoute permissionKey="isDashboard">
        <Dashboards />
      </ProtectedRoute>
    ),
  },

  { url: "/user-list",     component: (
      <ProtectedRoute permissionKey="misManagement">
        <Userlist />
      </ProtectedRoute>
    ),},
   { url: "waitlist",    component: (
      <ProtectedRoute permissionKey="waitListManagement">
        <Waitlist />
      </ProtectedRoute>
    ),},
     { url: "contact-us",  component: (
      <ProtectedRoute permissionKey="contactUsManagement">
        <ContactList />
      </ProtectedRoute>
    ), },
      { url: "listings",     component: (
      <ProtectedRoute permissionKey="adsManagement">
        <Listing />
      </ProtectedRoute>
    ),
},
 { url: "interested-ads",     component: (
      <ProtectedRoute permissionKey="interestedAds">
        <ExpressInterest />
      </ProtectedRoute>
    ),
},
{ url: "notification",    component: (
      <ProtectedRoute permissionKey="notificationManagement">
        <SendNotification />
      </ProtectedRoute>
    ), },

{ url: "terms-condition",  
   component: (
      <ProtectedRoute permissionKey="legalPagesManagement">
        <Terms />
      </ProtectedRoute>
    )
},
{ url: "new-request",   component: (
      <ProtectedRoute permissionKey="userManagement">
        <NewRequest />
      </ProtectedRoute>
    )},


 {url:"listing-detail/:id",component:(

     <ProtectedRoute permissionKey="adsManagement">
        <FlatDetailPage />
      </ProtectedRoute>)


 },

  {url:"user-detail/:id",component:<UserDetailPage/>},
   {url:"interested-ad-detail/:id",component:<InterestedUsersPage/>},

  {url:"safetychecks",component:(
  <ProtectedRoute permissionKey="safetyCheckManagement"><SafetyChecks/></ProtectedRoute>)},


{ url: "privacy-policy",   component: (
      <ProtectedRoute permissionKey="legalPagesManagement">
        <PrivacyPolicy />
      </ProtectedRoute>
    ), },
 { url: "about",  component: (
      <ProtectedRoute permissionKey="legalPagesManagement">
        <About />
      </ProtectedRoute>
    ),},
 { url: "deleted-users",    component: (
      <ProtectedRoute permissionKey="deleteAccountManagement">
        <DeleteUsers />
      </ProtectedRoute>
    ), },
{url:"denied",component:<AccessDenied/>},
{url:"alerts",component:<AlertPage/>},
 {url:"user-chat/:id",component:<ChatUI/>},
{ url: "role", component: <Role /> },
 
  { url: "assign-role", component: <CreateAdmin /> },
  { url: "blocked-chat", component: (
     <ProtectedRoute permissionKey="blockedUserManagement">
  <BlockedChats /> </ProtectedRoute>)},
   { url: "reported-chat", component :(  <ProtectedRoute permissionKey="reportManagement">
   <ReportedUser /></ProtectedRoute> )},
 
            { url: "/admin/about-form", component: 
                 (
      <ProtectedRoute permissionKey="legalPagesManagement">
        <AboutForm />
      </ProtectedRoute>
    )
              },
  ];

  return (
    <>
      <Routes>
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  //const { menuToggle, sidebariconHover } = useContext(ThemeContext);
  return (
    <>
      <div id="main-wrapper" className={`show`}>
        {/* <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle": ""} ${ menuToggle ? "menu-toggle" : ""}`}>   */}
        <Nav />
        <div
          className="content-body"
          style={{ minHeight: window.screen.height - 140 }}
        >
          <div className="container-fluid bdy">
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
function FrontLayout() {
  return (
    <>
      <div className="overflow-unset">
        {/* <Layout /> */}
        <Outlet />
      </div>
    </>
  );
}

export default Markup;
